"use client";

import {
	DATABASE_SCHEMA_OUT_OF_DATE_HINT,
	databaseConnectionUserMessage,
} from "@/lib/db-connection-user-message";

/**
 * Catches errors in the root layout (e.g. optional head-slot DB lookups).
 * Must define its own `html` and `body` — the root layout is not rendered.
 */
export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	const dbMsg = databaseConnectionUserMessage(error);
	const title =
		dbMsg === DATABASE_SCHEMA_OUT_OF_DATE_HINT
			? "Database / client schema mismatch"
			: dbMsg
				? "Site temporarily unavailable"
				: "Something went wrong";

	return (
		<html lang="en">
			<body className="antialiased">
				<div className="mx-auto max-w-lg px-4 py-16 text-center font-sans">
					<h1 className="font-semibold text-2xl tracking-tight">{title}</h1>
					<p className="mt-2 text-neutral-600 text-sm">
						{dbMsg ?? "The site could not be loaded. Try again in a moment."}
					</p>
					<button
						className="mt-6 rounded-md bg-neutral-900 px-4 py-2 text-sm text-white hover:bg-neutral-800"
						onClick={reset}
						type="button"
					>
						Try again
					</button>
				</div>
			</body>
		</html>
	);
}
